module.exports = __webpack_public_path__ + "assets/img/thumb-SEOClarity-Landing-Page-+-Website.8d7bf3ed.webp";